// Locale-aware formatting for the shared reference prices (shared/pricing.ts).
// "de" renders 39,99 €, "en" renders €39.99 — one numeric source, formatted
// per language instead of hand-written per locale file.
import { PRICING } from "@shared/pricing";

export function formatPrice(amount: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: PRICING.currency,
  }).format(amount);
}
